import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { addRequestedConnection } from 'store/globalState/reducers/userConnections';
import FinishSpeedDatingNotification from '../components';

const mapStateToProps = state => ({
  literals: state.i18n.literals.notificationsModal,
  actualUser: state.session.user,
  myNetwork: state.userConnections.connections,
  requestConnections: state.userConnections.requested,
});

function mapDispatchToProps(dispatch) {
  return {
    addRequestedConnection: bindActionCreators(addRequestedConnection, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(FinishSpeedDatingNotification);



// WEBPACK FOOTER //
// ./src/components/NotificationsTypes/FinishSpeedDating/container/index.js